export class TemplateKeyword {
    append(target, original) {
        const span = document.createElement('span');
        span.innerText = original.innerText;
        span.className = 'keyword keyword-' + original.getAttribute('type');
        target.appendChild(span);
    }
}
